export enum AccommodationRequestTableColumns {
  Week = "Week",
  Consultant = "Consultant",
  City = "City",
  ArrivalDate = "ArrivalDate",
  Sender = "Sender",
  Status = "Status",
  // Priority = "Priority",
  CreatedOn = "CreatedOn"
}
